var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuTitle',{attrs:{"close":_vm.close}},[_vm._v(_vm._s(_vm.$t('model.footerText')))]),_vm._v(" "),_c('DeleteBlockDialogTrigger',{on:{"delete-block":_vm.deleteBlock}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }